<i18n>
{
  "en": {
    "Success": "Les listes corporatives ont été changées avec succès."
  },
  "fr": {
    "Success": "Les listes corporatives ont été changées avec succès."
  }
}
</i18n>
<template>
  <card>
    <b-row slot="header" align-v="center">
      <b-col cols="8">
        <h3 class="mb-0">Listes corporatives</h3>
      </b-col>
    </b-row>

    <BaseForm
      id="mes-listes-corporatives"
      ref="user-listes-corporatives"
      classes="form"
      :on-success="updateListesCorporatives"
      :success-message="$t('Success')"
      :toast-only="true"
    >
      <h2 class="heading-small text-muted mb-4">Listes corporatives de l'utilisateur</h2>

      <BaseInput label="Accès aux listes corporatives">
        <TransferInput
          v-model="businessSchoolListIds"
          :data="businessSchoolListOptions"
          :titles="[
            'Toutes les listes corporatives',
            'Listes corporatives de l\'utilisateur',
          ]"
        />
      </BaseInput>
    </BaseForm>

    <b-row slot="footer" align-v="center">
      <b-col cols="12">
        <BaseButton type="default" @click.prevent="$refs['user-listes-corporatives'].submit()">
          Enregistrer les listes corporatives
        </BaseButton>
      </b-col>
    </b-row>
  </card>
</template>

<script>
import { BaseButton, BaseInput, Card } from '@coop-zone/coop-zone-argon'
import { mapState } from 'vuex'
import BaseForm from '@/components/forms/BaseForm'
import TransferInput from '@/components/Inputs/TransferInput'

export default {
  name: 'UserBusinessSchoolListEditForm',
  components: {
    BaseButton,
    BaseForm,
    BaseInput,
    Card,
    TransferInput,
  },
  data() {
    return {
      businessSchoolListIds: [],
      loading: false,
      businessSchoolListOptions: [],
    }
  },
  computed: {
    ...mapState('users', ['user']),
    businessSchoolListIds: {
      get() {
        return this.$store.state.users.businessSchoolListIds
      },
      set(businessSchoolListIds) {
        this.$store.commit('users/setBusinessSchoolListIds', businessSchoolListIds)
      },
    },
  },
  watch: {
    user: {
      handler(newVal) {
        this.businessSchoolListIds = newVal.businessSchoolListIds
      },
      immediate: true,
    },
  },
  async created() {
    this.loading = true
    const schoolLists = await this.$store.dispatch('schoolLists/searchSchoolLists', {
      types: ['BUSINESS'],
    })
    this.businessSchoolListOptions = schoolLists.map((schoolList) => {
      return {
        key: schoolList.id,
        label: schoolList.name,
      }
    })
    this.loading = false
  },
  mounted() {
    this.$store.dispatch('users/getUser', this.$route.params.id)
  },
  methods: {
    async updateListesCorporatives() {
      await this.$store.dispatch('users/updateBusinessSchoolListIds', {
        accountId: this.$route.params.id,
        listIds: this.businessSchoolListIds,
      })
      this.mode = 'readonly'
    },
  },
}
</script>
